import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export interface Breadcrumb {
	href?: string;
	text: string;
}

interface Props {
	breadcrumbs: Breadcrumb[];
}

const BreadcrumbsContainer = (props: Props) => {
	const { breadcrumbs } = props;
	const navigate = useNavigate();

	const breadcrumbItems = breadcrumbs.map((breadcrumb, index) => {
		const onBreadcrumbClick = () => {
			if (breadcrumb.href) {
				navigate(breadcrumb.href);
			}
		};

		return (
			<BreadcrumbLink
				key={index}
				color='inherit'
				href={null}
				onClick={onBreadcrumbClick}
			>
				{breadcrumb.text}
			</BreadcrumbLink>
		);
	});

	return <Breadcrumbs aria-label='breadcrumb'>{breadcrumbItems}</Breadcrumbs>;
};

const BreadcrumbLink = styled(Link)`
	font-size: 14px;
	color: #6b778c;
	cursor: pointer;
	&:hover {
		color: #6b778c;
	}
`;

export default BreadcrumbsContainer;
